<template>
    <footer>
        <div class="row">
            <div class="col-12 footer-bottom">
                <p class="mb-0">
                    &copy; {{ new Date().getFullYear() }} Copyright AOarmor, LLC
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import { routing } from '@/mixins/routing';

export default {
    mixins: [routing],
    data() {
        return {
            publicPath: process.env.BASE_URL,
        };
    },
    created() {
        const url = window.location.href;

        if (!url.includes('localhost') && !url.includes('127.0.0.1')) {
            // TODO(We might want to add another chat window for this when it gets going.)
        }
    },
};
</script>
